module.exports = __webpack_public_path__ + "static/media/underConstruction.bd8d3a25.png";